import classnames from "classnames";
import React, { JSX, ReactNode, useEffect } from "react";
import { createPortal } from "react-dom";

import { useScrollLock } from "@utils/hooks/useScrollLock";

import { Button } from "@components/General/Button/button.component";
import { Overlay } from "@components/Overlay/overlay.component";

import "./asideFlyout.scss";

type FloutProps = {
    children: ReactNode;
    open: boolean;
    onClose: () => void;
    closeButtonText: string;
    container?: Element | DocumentFragment | null;
    extraButtons?: JSX.Element;
    className?: string;
};

const ASIDE_FLYOUT_SCROLL_LOCK = "aside-flyout";

const AsideFlyout = ({
    children,
    open = false,
    onClose,
    closeButtonText,
    container,
    extraButtons,
    className,
}: FloutProps) => {
    const { lock, unlock } = useScrollLock(ASIDE_FLYOUT_SCROLL_LOCK);
    const containerElement = container || document.body;

    useEffect(() => {
        (open ? lock : unlock)();
    }, [open]);

    const flyout = (
        <Overlay isOpen={open} onClose={onClose} overlayHeader={true}>
            <aside
                className={classnames(
                    "asideFlyout position-absolute vw-100",
                    className,
                    open && "asideFlyout--open",
                )}
            >
                <div
                    className={
                        "asideFlyout__flyout position-fixed w-100 d-flex flex-column"
                    }
                >
                    <div className={"asideFlyout__content p-3 overflow-auto"}>
                        {children}
                    </div>
                    <div
                        className={
                            "asideFlyout__controls w-100 d-flex justify-content-end p-2"
                        }
                    >
                        {extraButtons}
                        <Button type={"button"} onClick={onClose}>
                            {closeButtonText}
                        </Button>
                    </div>
                </div>
            </aside>
        </Overlay>
    );

    return createPortal(flyout, containerElement);
};

export { AsideFlyout };
